const mapGiftCard = giftCard => {
  return {
    amount: giftCard.amount,
    remaining_amount: giftCard.remaining_amount,
    currency: giftCard.currency,
  }
}

export const transformResponseGetGiftCard = giftCard => (giftCard ? mapGiftCard(giftCard) : giftCard)
